const onlyLettersAndHyphen = /[^a-zA-Z\- ]/;

const fieldsDefinition = async () => [
  [
    {
      id: 'name',
      label: 'Agency Name',
      type: 'text',
      hint: 'Enter a agency name',
      restrictions: onlyLettersAndHyphen,
    },
    {
      id: 'partnerID',
      label: 'Partner ID',
      type: 'text',
      hint: 'Enter a partner id',
    },
  ],
  [
    {
      id: 'partnerAgencyID',
      label: 'Partner Agency ID',
      type: 'text',
      hint: 'Enter a partner agency id',
    },
  ],
];

export default fieldsDefinition;
